import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import MinusSquareTwoToneSvg from "@ant-design/icons-svg/es/asn/MinusSquareTwoTone";
import AntdIcon from "../components/AntdIcon";
var MinusSquareTwoTone = function MinusSquareTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MinusSquareTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  MinusSquareTwoTone.displayName = 'MinusSquareTwoTone';
}
export default /*#__PURE__*/React.forwardRef(MinusSquareTwoTone);